import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, getFormValues, change } from 'redux-form';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas } from '../../../../../helpers';
import { updatePaginationSkip } from '../../../../../../reducers/calculator';
import { formDetails as StepOneFormDetails } from '../step-one';
import { formDetails as StepTwoFormDetails } from '../step-two';
import { formDetails as StepThreeFormDetails } from '../step-three';
import { formDetails as StepFiveFormDetails } from '../step-five';
import { formDetails as StepSixFormDetails } from '../step-six';
import { formDetails as StepSevenFormDetails } from '../step-seven';
import { formDetails as StepEightFormDetails } from '../step-eight';
import { formDetails as StepNineFormDetails } from '../step-nine';

export const formDetails = {
    key: 'summary',
    title: 'Summary',
    formName: Routes.SUMMARY,
    summaryFieldsKey: 'summaryFields'
};

export const formName = Routes.SUMMARY;

class SummaryForm extends Component {
    createState(){
        const {
            summaryFields
        } = this.props;
        const arr = summaryFields
            .map(obj => obj.key)
            .reduce((total, val) => {
                total[val] = false;
                return total;
            }, {});
        return arr;
    }

    state = this.createState();

    render() {
        const {
            props: {
                stepOneSummary,
                stepTwoSummary,
                stepThreeSummary,
                financialSummary,
                stepNineSummary,
                prosperityPath
            }
        } = this;

        const expandAccordion = (e, state) => {
            e.preventDefault();
            this.setState({[state]: !this.state[state]});
        };

        const isNegative = value => value < 0;

        const formatCurrency = value =>
            `${isNegative(value) ? '-' : ''}$${numberWithCommas(Math.abs(value))}`;

        return (
            <form className={`print-only ${styles.form}`}>
                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <p className={styles.topTitle}>{stepOneSummary.category}</p>
                        <div className={this.state[stepOneSummary.key] ? styles.accordionItemActive : styles.accordionItem}>
                            <button className={styles.accordionHeader} title={ stepOneSummary.customTitle || stepOneSummary.title } onClick={e => expandAccordion(e, stepOneSummary.key)}>
                                <span className={styles.accordionTitle}>{ stepOneSummary.customTitle || stepOneSummary.title }</span>
                            </button>
                            <div className={styles.accordionContent}>
                                <p className={styles.value}>{stepOneSummary.value}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <p className={styles.topTitle}>{stepTwoSummary.category}</p>
                        <div className={this.state[stepTwoSummary.key] ? styles.accordionItemActive : styles.accordionItem}>
                            <button className={styles.accordionHeader} title={ stepTwoSummary.customTitle || stepTwoSummary.title } onClick={e => expandAccordion(e, stepTwoSummary.key)}>
                                <span className={styles.accordionTitle}>{ stepTwoSummary.customTitle || stepTwoSummary.title }</span>
                            </button>
                            <div className={styles.accordionContent}>
                                <ul className={styles.summaryListLong}>
                                    {
                                        Object.keys(stepTwoSummary.value).map(key =>
                                            <li key={key}>
                                                <span className={styles.optionsTitle}>{stepTwoSummary.fields[key].label}</span>
                                                <strong className={styles.optionsValue}>{stepTwoSummary.value[key] !== '' ? stepTwoSummary.value[key] : 'N/A'}</strong>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <p className={styles.topTitle}>{stepThreeSummary.category}</p>
                        <div className={this.state[stepThreeSummary.key] ? styles.accordionItemActive : styles.accordionItem}>
                            <button className={styles.accordionHeader} title={ stepThreeSummary.customTitle || stepThreeSummary.title } onClick={e => expandAccordion(e, stepThreeSummary.key)}>
                                <span className={styles.accordionTitle}>{ stepThreeSummary.customTitle || stepThreeSummary.title }</span>
                            </button>
                            <div className={styles.accordionContent}>
                                <ul className={styles.summaryList}>
                                    {
                                        Object.keys(stepThreeSummary.value).map(key =>
                                            stepThreeSummary.value[key] !== "0" && (
                                                <li key={key}>
                                                    <span className={styles.optionsTitle}>{stepThreeSummary.fields[key].label}</span>
                                                    <strong className={styles.optionsValue}>{stepThreeSummary.rangeValues[stepThreeSummary.value[key]]}</strong>
                                                </li>
                                            )
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    !prosperityPath && financialSummary.map((field) =>
                        <div key={field.key} className={styles.formSection}>
                            <div className={styles.sectionDivider}>
                                <p className={styles.topTitle}>{field.category}</p>
                                <div className={this.state[field.key] ? styles.accordionItemActive : styles.accordionItem}>
                                    <button className={styles.accordionHeader} title={ field.customTitle || field.title } onClick={e => expandAccordion(e, field.key)}>
                                        <span className={styles.accordionTitle}>{ field.customTitle || field.title }</span>
                                        <span className={styles.accordionTitle}>Total: <strong>{formatCurrency(field.total)}</strong></span>
                                    </button>
                                    <div className={styles.accordionContent}>
                                        <ul className={styles.summaryList}>
                                            {
                                                Object.keys(field.value).map(key =>
                                                    <li key={key}>
                                                        <span className={styles.summaryTitle}>{field.fields[key].label}:</span>
                                                        <strong className={styles.summaryValue}>{formatCurrency(field.value[key])}</strong>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                <div className={styles.formSection}>
                    <div className={styles.sectionDivider}>
                        <p className={styles.topTitle}>{stepNineSummary.category}</p>
                        <div className={this.state[stepNineSummary.key] ? styles.accordionItemActive : styles.accordionItem}>
                            <button className={styles.accordionHeader} title={ stepNineSummary.customTitle || stepNineSummary.title } onClick={e => expandAccordion(e, stepNineSummary.key)}>
                                <span className={styles.accordionTitle}>{ stepNineSummary.customTitle || stepNineSummary.title }</span>
                            </button>
                            <div className={styles.accordionContent}>
                                <ul className={styles.summaryListLong}>
                                    {
                                        Object.keys(stepNineSummary.value).map(key =>
                                            <li key={key}>
                                                <span className={styles.optionsTitle}>{stepNineSummary.fields[key].label}</span>
                                                <strong className={styles.optionsValue}>{stepNineSummary.value[key] !== '' ? stepNineSummary.value[key] : 'N/A'}</strong>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

SummaryForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    redirectPath: `/prosperity-planner${Routes.SUMMARY}`
})(SummaryForm);


const StepOneForm = formValueSelector(StepOneFormDetails.formName);
const StepOneFormValues = getFormValues(StepOneFormDetails.formName);
const StepTwoForm = formValueSelector(StepTwoFormDetails.formName);
const StepTwoFormValues = getFormValues(StepTwoFormDetails.formName);
const StepThreeForm = formValueSelector(StepThreeFormDetails.formName);
const StepThreeFormValues = getFormValues(StepThreeFormDetails.formName);
const StepFiveForm = formValueSelector(StepFiveFormDetails.formName);
const StepFiveFormValues = getFormValues(StepFiveFormDetails.formName);
const StepSixForm = formValueSelector(StepSixFormDetails.formName);
const StepSixFormValues = getFormValues(StepSixFormDetails.formName);
const StepSevenForm = formValueSelector(StepSevenFormDetails.formName);
const StepSevenFormValues = getFormValues(StepSevenFormDetails.formName);
const StepEightForm = formValueSelector(StepEightFormDetails.formName);
const StepEightFormValues = getFormValues(StepEightFormDetails.formName);
const StepNineForm = formValueSelector(StepNineFormDetails.formName);
const StepNineFormValues = getFormValues(StepNineFormDetails.formName);

const mapStateToProps = (state) => {
    if(!StepOneForm(state, StepOneFormDetails.totalKey)){
        return {
            summaryFields: [],
            stepOneSummary: {},
            stepTwoSummary: {},
            stepThreeSummary: {},
            stepNineSummary: {},
            financialSummary: []
        };
    }

    const oneWordTotal = StepOneForm(state, StepOneFormDetails.totalKey);
    const {
        [StepOneFormDetails.totalKey]: oneWordValues = ''
    } = StepOneFormValues(state) || {};

    const startingPointTotal = StepTwoForm(state, StepTwoFormDetails.totalKey);
    const {
        [StepTwoFormDetails.totalKey]: removedStartingPointTotal,
        ...startingPointValues
    } = StepTwoFormValues(state) || {};

    const mustDoLoveToTotal = StepThreeForm(state, StepThreeFormDetails.totalKey);
    const {
        [StepThreeFormDetails.totalKey]: removedMustDoLoveToTotal,
        loveToTotal,
        mustDoTotal,
        ...mustDoLoveToValues
    } = StepThreeFormValues(state) || {};

    const whatIHaveTotal = StepFiveForm(state, StepFiveFormDetails.totalKey);
    const {
        [StepFiveFormDetails.totalKey]: removedWhatIHaveTotal,
        ...whatIHaveValues
    } = StepFiveFormValues(state) || {};

    const whatIOweTotal = StepSixForm(state, StepSixFormDetails.totalKey);
    const {
        [StepSixFormDetails.totalKey]: removedWhatIOweTotal,
        ...whatIOweValues
    } = StepSixFormValues(state) || {};

    const whatIReceiveTotal = StepSevenForm(state, StepSevenFormDetails.totalKey);
    const {
        [StepSevenFormDetails.totalKey]: removedWhatIReceiveTotal,
        ...whatIReceiveValues
    } = StepSevenFormValues(state) || {};

    const whatISpendTotal = StepEightForm(state, StepEightFormDetails.totalKey);
    const {
        [StepEightFormDetails.totalKey]: removedWhatISpendTotal,
        ...whatISpendValues
    } = StepEightFormValues(state) || {};

    const myGoalsTotal = StepNineForm(state, StepNineFormDetails.totalKey);
    const {
        [StepNineFormDetails.totalKey]: removedMyGoalsTotal,
        ...myGoalsValues
    } = StepNineFormValues(state) || {};

    const stepOneSummary = {
        category: 'Prosperity',
        ...StepOneFormDetails,
        total: oneWordTotal || '',
        value: oneWordValues || 0
    };
    const stepTwoSummary = {
        category: 'Starting Points',
        customTitle: 'What does your future look like?',
        ...StepTwoFormDetails,
        total: startingPointTotal || '',
        value: startingPointValues || {}
    };
    const stepThreeSummary = {
        category: 'Must Do Love to',
        ...StepThreeFormDetails,
        total: mustDoLoveToTotal || 0,
        value: mustDoLoveToValues || {}
    };
    const stepFiveSummary = {
        category: 'Money Now',
        ...StepFiveFormDetails,
        total: whatIHaveTotal || 0,
        value: whatIHaveValues || {}
    };
    const stepSixSummary = {
        category: 'Money Then',
        ...StepSixFormDetails,
        total: whatIOweTotal || 0,
        value: whatIOweValues || {}
    };
    const stepSevenSummary = {
        category: 'Money In',
        ...StepSevenFormDetails,
        total: whatIReceiveTotal || 0,
        value: whatIReceiveValues || {}
    };
    const stepEightSummary = {
        category: 'Money Out',
        ...StepEightFormDetails,
        total: whatISpendTotal || 0,
        value: whatISpendValues || {}
    };
    const stepNineSummary = {
        category: 'My Goals',
        customTitle: 'What will you do this year?',
        ...StepNineFormDetails,
        total: myGoalsTotal || '',
        value: myGoalsValues || {}
    };

    const financialSummary = [
        stepFiveSummary,
        stepSixSummary,
        stepSevenSummary,
        stepEightSummary
    ];

    const summaryFields = [
        stepOneSummary,
        stepTwoSummary,
        stepThreeSummary,
        stepNineSummary,
        ...financialSummary
    ];

    return {
        summaryFields,
        stepOneSummary,
        stepTwoSummary,
        stepThreeSummary,
        stepNineSummary,
        financialSummary,
        prosperityPath: state.prosperity.skipFinancial
    }
};

const mapDispatchToProps = (dispatch) => ({
    changeFieldValue: (field, value) => dispatch(change(formDetails.formName, field, value)),
    updatePaginationSkip: dispatch(updatePaginationSkip)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SummaryForm);
